import { PURCHASE_NODE_ID_PATH_SERVICES } from "api/services/content/paths"

export const transformUrlPath = (url)=>{
    if(url.includes(PURCHASE_NODE_ID_PATH_SERVICES)) return `${url}${localStorage.getItem('object_id')}`
    return url

}